import axios from '../../axios';
import {
   GET_ALL_DASHBOARD_WHATS_NEW,
   GET_ROJMEL,
   GET_TOTAL_SALES_AND_PURCHASES,
   GET_TOP_FIVE_PARTY_WISE_PURCHASE,
   GET_TOP_FIVE_PARTY_WISE_SALES,
   GET_MONTHLY_SALES_SUMMARY,
   GET_MONTHLY_PURCHASE_SUMMARY,
   GET_QUARTERLY_SALES_SUMMARY,
   GET_QUARTERLY_PURCHASE_SUMMARY,
   GET_GROWTH_RATE,
   GET_DAY_OF_WEEK_PERFORMANCE,
   GET_TOP_TO_BOTTOM_PERFORMANCE,
   GET_MOVING_AVERAGE_TRENDS,
   GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER,
   GET_CASH_FLOW_ANALYSIS,
   GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS,
   GET_AGING_ANALYSIS,
   GET_HEATMAP_DATA,
   GET_YEAR_OVER_YEAR_COMPARISON,
   GET_CUSTOMER_CONCENTRATION_ANALYSIS,
   GET_WEEKLY_PERFORMANCE_TRENDS,
   GET_CITY_WISE_SALES,
   GET_EXCEPTION_REPORTING,
   GET_MONTHLY_CUSTOMER_SALES,
   GET_CUSTOMER_SALES_VALUE,
   GET_FINANCIAL_YEARS,
   GET_CASH_AND_BANK_BALANCE,
   GET_RECEIVE_AND_PAY,
   GET_SALES_PAYMENT_RECEIVE_REPORT,
   GET_PURCHASE_PAID_REPORT,
   GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT,
   GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT,
   DELETE_OVER_ADJUSTED,
   DELETE_EXTRA_OVER_ADJUSTED,
   DELETE_EXTRA_LEDGER_ENTRIES,
   SALES_PURCHASES_OVERVIEW,
   GET_BARCODE_DATA,
   SAVE_BARCODE_DATA,
   UPDATE_BULK_STATUS,
   GET_BALANCE,
   UPDATE_UTILITY,
} from '../types';
import { toast } from 'react-toastify';

export const getWhatsNew = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/whatsNew`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ALL_DASHBOARD_WHATS_NEW,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getRojmel = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/getRojmel`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ROJMEL,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

// TOTAL SALES AND PURCHASES
export const getTotalSalesAndPurchases = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/totalSalesAndPurchase`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TOTAL_SALES_AND_PURCHASES,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getTopFivePartyWisePurchase = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/topFivePartyWiseTransactions`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TOP_FIVE_PARTY_WISE_PURCHASE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getTopFivePartyWiseSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/topFivePartyWiseTransactions`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TOP_FIVE_PARTY_WISE_SALES,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getMonthlySalesSummary = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/monthlySalesSummary`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_MONTHLY_SALES_SUMMARY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getMonthlyPurchaseSummary = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/monthlyPurchaseSummary`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_MONTHLY_PURCHASE_SUMMARY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getQuarterlySalesSummary = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/quarterlySalesSummary`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_QUARTERLY_SALES_SUMMARY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getQuarterlyPurchaseSummary = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/quarterlyPurchaseSummary`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_QUARTERLY_PURCHASE_SUMMARY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getGrowthRate = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/growthRate`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_GROWTH_RATE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getDayOfWeekPerformance = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/dayOfWeekSales`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DAY_OF_WEEK_PERFORMANCE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCashItcLedger = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/reports/cashItcBalance`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DAY_OF_WEEK_PERFORMANCE,
            payload: res.data.data,
         });
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
         return err.response.data;
      }
   }
};

export const getTopToBottomPerformance = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/topToBottomSales`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TOP_TO_BOTTOM_PERFORMANCE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getMovingAverageTrends = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/movingAverageTrends`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_MOVING_AVERAGE_TRENDS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getProfitabilityAnalysisByCustomer = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/profitabilityAnalysisByCustomer`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCashFlowAnalysis = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/cashFlowAnalysis`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CASH_FLOW_ANALYSIS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getTransactionSizeDistributionAnalysis = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/transactionSizeDistributionAnalysis`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getAgingAnalysis = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/agingAnalysis`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_AGING_ANALYSIS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getHeatmapData = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/heatmapData`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_HEATMAP_DATA,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getYearOverYearComparison = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/yearOverYearComparison`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_YEAR_OVER_YEAR_COMPARISON,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCustomerConcentrationAnalysis = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/customerConcentrationAnalysis`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CUSTOMER_CONCENTRATION_ANALYSIS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getWeeklyPerformanceTrends = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/weeklyPerformanceTrends`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_WEEKLY_PERFORMANCE_TRENDS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCityWiseSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/cityWiseSales`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CITY_WISE_SALES,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getExceptionReporting = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/exceptionReporting`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_EXCEPTION_REPORTING,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getMonthlyCustomerSales = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/monthlyCustomerSales`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_MONTHLY_CUSTOMER_SALES,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCustomerSalesValue = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/customerSalesValue`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CUSTOMER_SALES_VALUE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getFinancialYears = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/financialYears`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_FINANCIAL_YEARS,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getCashAndBankBalance = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/cashAndBankBalance`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_CASH_AND_BANK_BALANCE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getReceiveAndPay = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/receiveAndPay`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_AND_PAY,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getSalesPaymentReceiveReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/salesPaymentReceiveReport`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_SALES_PAYMENT_RECEIVE_REPORT,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getPurchasePaidReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/purchasePaidReport`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_PAID_REPORT,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getLastFiveYearSalesComparisonReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/lastFiveYearSalesComparisonReport`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getLastFiveYearPurchaseComparisonReport = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/lastFiveYearPurchaseComparisonReport`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const deleteOverAdjusted = () => async (dispatch) => {
   try {
      const res = await axios.post(`/outAdjustment/delete/overAdjusted`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_OVER_ADJUSTED, payload: res.data });
         // toast.success('overAdjusted deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const deleteExtraOutAdj = () => async (dispatch) => {
   try {
      const res = await axios.post(`/outAdjustment/delete/extraOutAdj`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_EXTRA_OVER_ADJUSTED, payload: { res } });
         // toast.success('extraOutAdj deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const deleteLedgerEntries = () => async (dispatch) => {
   try {
      const res = await axios.post(`/ledger/delete/extraLedgerEntries`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_EXTRA_LEDGER_ENTRIES, payload: { res } });
         // toast.success('extraLedger deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const salePurchaseOverview = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/topFivePartyWiseTransactions`, {
         params,
      });
      if (res.data.code === 1) {
         dispatch({ type: SALES_PURCHASES_OVERVIEW, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getBarcodeData = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/utility/imei`, {
         params,
      });
      if (res.data.code === 1) {
         dispatch({ type: GET_BARCODE_DATA, payload: res.data.data });
         return res.data;
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const SaveBarcodeData = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/utility/update/specifications`, formData);
      if (res.data.code === 1) {
         dispatch({ type: SAVE_BARCODE_DATA, payload: res.data.data });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const UpdateBulkStatus = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/company/update_bulk_status`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_BULK_STATUS, payload: res.data.data });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getBalance = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/gstBal`, { params });
      console.log('API Full Response:', res.data.data);

      if (res.data.code === 1) {
         // Store the ENTIRE response, not just res.data.data
         dispatch({ type: GET_BALANCE, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.log('API Error:', err);
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
